import { P2Button, P2TextDescription, P2TextLabel } from 'react-bootstrap-common-script';
import ApplicationCooLayout from '../../../layout/application-coo-layout';
import { Separator } from '../../../components/separator';
import { useNavigate } from 'react-router-dom';
import { SectionCard } from '../../../components/card';
import { Stepper } from '../../../components/stepper';
import { R2stepperItemsStageE } from '../../../utils/shared-dropdown';
import OverViewSegment from './overview-segment';
import useViewportWidth from '../../../components/stepper/useViewportWidth';
import { useAppSelector } from '../../../redux/hook';
import { useGetApplicationUuid } from '../../../hooks/useGetApplicationUuid';
const activeStep = 1;

function StageECpfOverview() {
  const isDesktopView = useViewportWidth();
  const navigate = useNavigate();

  const applicationId = useGetApplicationUuid();
  const loginUser = useAppSelector((state) => state.auth.AuthenticationSlice.loginUser) ?? '';
  const singpassToken = useAppSelector((state) => state.auth.AuthenticationSlice.singpassToken) ?? '';

  const handleNavigateBack = () => {
    navigate(`/application-coo/stage-e/cpf-e-service?application_id=${applicationId}`);
  };

  const handleProceedNext = () => {
    navigate(`/application-coo/stage-e/request-use-of-cpf?application_id=${applicationId}`);
  };

  return (
    <ApplicationCooLayout title='Apply to Withdraw CPF Funds Due to Change in Flat Ownership'>
      <div className='polymer-application-coo__wrapper cpf-wrapper'>
        <div>
          <Stepper activeStep={activeStep} items={R2stepperItemsStageE} />
        </div>
        <div className='d-flex flex-column align-items-center gap-3 gap-md-5'>
          {/* Section Card */}
          <SectionCard
            required={true}
            className='flex-fill'
            activeStep={activeStep}
            stepperItems={R2stepperItemsStageE}
            titleChildren={<P2TextDescription title={R2stepperItemsStageE[activeStep - 1]?.title} />}
            contentChildren={
              <div className='polymer-stage-e cpf-container'>
                <div>
                  <P2TextLabel bold={700} label={'Summary'} fontSize={isDesktopView ? '24px' : '20px'} lineHeight={isDesktopView ? '28px' : '24px'} />
                </div>
                <OverViewSegment loginUserUinfin={loginUser?.uinfin ?? ''} applicationId={applicationId ?? '0'} singpassToken={singpassToken} />
              </div>
            }
          />

          {/* Seperator */}
          <div className='cpf-wrapper_seperator'>
            <Separator />
          </div>

          {/* Button Group */}
          <div className='cpf-wrapper_button-wrapper'>
            <div className='cpf-wrapper_button-group'>
              <P2Button onClick={() => handleNavigateBack()} variant={'outline-primary'}>
                Back
              </P2Button>
              <P2Button onClick={() => handleProceedNext()} variant={'primary-1'}>
                Continue
              </P2Button>
            </div>
          </div>
        </div>
      </div>
    </ApplicationCooLayout>
  );
}

export default StageECpfOverview;
